module.exports = __webpack_public_path__ + "img/double-quotes-l.ef586501.svg";